export enum NotRecommendedProductStatus {
  REQUIREMENTS_OK = 'requirement_ok',
  REQUIREMENTS_PARTIAL = 'requirement_partial',
  REQUIREMENTS_KO = 'requirement_ko',
}
